import React from 'react';
import { isMobile } from 'react-device-detect';
import CardBg10 from 'assets/images/dashboard/card10.png';
import { formatStatsValue } from 'common-helpers/utils';
import Row, { RowBetween } from 'components/Row';
import { AutoColumn } from 'components/Column';
import { TYPE } from 'theme';
import { UserGecStatsV2 } from 'gql-ops/graph/__generated__/request';
import { CardContent, CardSeason4 } from './seasonStyles';
import ClaimRecord from './ClaimRecord';

interface Season4Props {
    gecStatsV2: UserGecStatsV2;
}

const Season4: React.FC<Season4Props> = ({ gecStatsV2 }) => {
    return (
        <>
            <RowBetween>
                <TYPE.main fontSize={16} fontWeight={700} mobileFz={14}>
                    Season 4 (Ended)
                </TYPE.main>
                <TYPE.desc color="#F7931A" fontSize={16} fontWeight={700}>
                    Points updated every 60 mins (GOATUP Points updated at 00:00 UTC.)
                </TYPE.desc>
            </RowBetween>
            <CardSeason4
                backgroundImage={CardBg10}
                bgIcon="rocket"
                height={isMobile ? 'auto' : '169px'}
                width="100%"
                padding="20px"
            >
                <CardContent>
                    <AutoColumn gap="6px">
                        <TYPE.desc fontSize={14} fontWeight={500}>
                            GOAT points
                        </TYPE.desc>
                        <TYPE.desc fontSize={10} color="#999">
                            GOAT Points are used to receive airdrop
                        </TYPE.desc>
                    </AutoColumn>
                    <RowBetween gap="20px" align="center" alignItems="center" marginTop="20px" wrap="wrap">
                        <AutoColumn style={{ height: '50px' }}>
                            <TYPE.main fontSize={10}>Total Points</TYPE.main>
                            <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                <TYPE.main fontSize={24} fontWeight={500}>
                                    +
                                    {formatStatsValue(
                                        BigInt(gecStatsV2.season4Stats.totalEarnedPoints || '0').toString(),
                                    )}
                                </TYPE.main>
                                <TYPE.desc fontSize={14}>Points</TYPE.desc>
                            </Row>
                        </AutoColumn>
                        <AutoColumn style={{ height: '50px' }}>
                            <Row gap="2px">
                                <TYPE.main fontSize={10}>Consumed Points</TYPE.main>
                            </Row>
                            <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                <TYPE.main fontSize={24} fontWeight={500}>
                                    +
                                    {formatStatsValue(
                                        BigInt(gecStatsV2.season4Stats.totalConsumedPoints || '0').toString(),
                                    )}
                                </TYPE.main>
                                <TYPE.desc fontSize={14}>Points</TYPE.desc>
                            </Row>
                        </AutoColumn>
                        <AutoColumn style={{ height: '50px', visibility: 'hidden' }}>
                            <Row gap="2px">
                                <TYPE.main fontSize={10}>On Chain Points</TYPE.main>
                            </Row>
                            <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                <TYPE.main fontSize={24} fontWeight={500}>
                                    +
                                    {formatStatsValue(
                                        BigInt(gecStatsV2.season4Stats.totalConsumedPoints || '0').toString(),
                                    )}
                                </TYPE.main>
                                <TYPE.desc fontSize={14}>Points</TYPE.desc>
                            </Row>
                        </AutoColumn>
                    </RowBetween>
                </CardContent>
            </CardSeason4>
            <ClaimRecord />
        </>
    );
};

export default Season4;
